//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_LOGIN = "/login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

// CUSTOMERS
export const GET_CUSTOMERS = "/get_customers";
export const ADD_NEW_CUSTOMER = "/create_customer";
export const UPDATE_CUSTOMER = "/update_customer";
export const DELETE_CUSTOMER = "/delete_customers";
export const GET_CUSTOMER_DETAIL = "/get_customers_details";
export const EXPORT_CUSTOMER = "/export_customers";

// USER
export const GET_USERS = "/get_accounts";
export const ADD_NEW_USER = "/create_account";
export const UPDATE_USER = "/update_account";
export const ENABLE_DISABLE_ACCOUNT = "/enable_disable_account";
export const CHANGE_PASSWORD = "/update_account_password";
export const GET_DETAIL_USER = "/get_accounts_details";
export const REGISTER_ACCOUNT = "register_account";

// PRODUCTS
export const GET_PRODUCTS = "/get_products";
export const DELETE_PRODUCTS = "/delete_products";
export const CREATE_PRODUCT_NEW = "/create_product";
export const GET_STORES = "/get_store";
export const GET_PRODUCT_DETAIL = "/get_products_details";
export const UPDATE_PRODUCT_NEW = "/update_product";
export const EXPORT_PRODUCT = "/export_products";

//ORDERS
export const GET_ORDERS = "/get_orders";
export const GET_ORDER_DETAIL = "/get_orders_details";
export const GET_REPORT_ORDER = "/report_orders";
export const GET_REPORT_TOP_PRODUCT = "/report_orders_by_product";
export const GET_ORDER_OVERVIEW = "/overview_orders";
export const EXPORT_ORDER = "/export_order";

export const PICK_UP_ORDER = "/pickup_orders";
export const RETURN_ORDER = "/return_orders";
export const CANCEL_ORDER = "/cancel_orders";
export const CREATE_ORDER = "/create_order";
export const UPDATE_ORDER = "/update_order";

//STORE
export const CREATE_STORE = "/create_store";
export const GET_STORE_DETAIL = "/get_store_details";
export const UPDATE_STORE = "/update_store";
